// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Manufacturer } from './manufacturer';
import { StagedProductType } from './staged-product-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StagedFeedRun extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 */
  colorsStaged!: number;
  /** DateTimeOffset */
  completedTs?: Date;
  /** String(64) */
  crtnUserInit?: string;
  /** String(2000) */
  error?: string;
  /** Boolean */
  isComplete!: boolean;
  /** Int32 FK manufacturer */
  manufacturerId!: number;
  /** Int32 */
  partsStaged!: number;
  /** DateTimeOffset */
  startedTs!: Date;
  /** Int32 */
  stylesFailed!: number;
  /** Int32 */
  stylesRequested!: number;
  /** Int32 */
  stylesSucceeded!: number;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
  /** Inv FK stagedFeedRunId */
  stagedProductTypes!: StagedProductType[];
}

